"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.trim");

var _utils = require("../helpers/utils");
/*
 * Newsletter form functionality
 * Handles form validation,sanitisation, submission and success messaging
 *
 * @namespace newsletter-form
 */

/* eslint-env browser */
// DOM selectors


var SELECTORS = {
  form: '[js-newsletter="form"]',
  successMessage: '[js-newsletter="success-message"]',
  submitButton: '[js-newsletter="submit-btn"]',
  nameField: '[js-newsletter="name-field"]',
  emailField: '[js-newsletter="email-field"]',
  errorDiv: '[js-newsletter="email-error"]',
  nameErrorDiv: '[js-newsletter="name-error"]'
}; // Validation constants

var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var NAME_REGEX = /^[A-Za-z\s-]{3,}$/; // Basic sanitisation to prevent script injection

var sanitize = function sanitize(str) {
  return str.replace(/<[^>]*>?/gm, '').trim();
};
/**
 * Newsletter form module
 * @returns {Object} Public API
 */


var _default = function _default() {
  // Private state
  var state = {
    elements: {}
  };
  /**
   * Cache DOM elements for performance
   */

  var cacheElements = function cacheElements() {
    state.elements = {
      form: document.querySelector(SELECTORS.form),
      successMessage: document.querySelector(SELECTORS.successMessage),
      submitButton: document.querySelector("".concat(SELECTORS.form, " ").concat(SELECTORS.submitButton)),
      nameField: document.querySelector(SELECTORS.nameField),
      emailField: document.querySelector(SELECTORS.emailField),
      errorDiv: document.querySelector(SELECTORS.errorDiv),
      nameErrorDiv: document.querySelector(SELECTORS.nameErrorDiv)
    };
  };
  /**
   * Update submit button enabled/disabled state
   */


  var updateSubmitButtonState = function updateSubmitButtonState() {
    var _state$elements = state.elements,
        nameField = _state$elements.nameField,
        emailField = _state$elements.emailField,
        submitButton = _state$elements.submitButton;
    var nameValid = NAME_REGEX.test(sanitize(nameField.value));
    var emailValid = EMAIL_REGEX.test(sanitize(emailField.value)); // Update button visual state without disabling it

    if (nameValid && emailValid) {
      submitButton.classList.add('valid');
    } else {
      submitButton.classList.remove('valid');
    }
  };
  /**
   * Validate email and show/hide error message
   */


  var validateEmail = function validateEmail() {
    var _state$elements2 = state.elements,
        emailField = _state$elements2.emailField,
        errorDiv = _state$elements2.errorDiv;
    var sanitizedValue = sanitize(emailField.value);
    var isValid = EMAIL_REGEX.test(sanitizedValue); // Toggle error state

    errorDiv.style.display = isValid ? 'none' : 'flex';
    emailField.classList[isValid ? 'remove' : 'add']('error');
    updateSubmitButtonState();
  };
  /**
  * Validate first name and show error message
  */


  var validateName = function validateName() {
    var _state$elements3 = state.elements,
        nameField = _state$elements3.nameField,
        nameErrorDiv = _state$elements3.nameErrorDiv;
    var sanitizedValue = sanitize(nameField.value);
    var nameRequired = nameField.getAttribute('js-name-required-message');
    var nameMinLength = nameField.getAttribute('js-name-min-length-message');
    var nameFormat = nameField.getAttribute('js-name-format-message');
    var isValid = NAME_REGEX.test(sanitizedValue);

    if (isValid) {
      nameErrorDiv.textContent = '';
      nameErrorDiv.style.display = 'none';
      nameField.classList.remove('error');
    } else {
      if (sanitizedValue === '') {
        nameErrorDiv.textContent = nameRequired;
      } else if (sanitizedValue.length < 3) {
        nameErrorDiv.textContent = nameMinLength;
      } else {
        nameErrorDiv.textContent = nameFormat;
      }

      nameErrorDiv.style.display = 'flex';
      nameField.classList.add('error');
    }

    updateSubmitButtonState();
  };
  /**
   * Show success message or redirect after successful submission
   * @param {string|null} redirectUrl - URL to redirect to
   */


  var showSuccess = function showSuccess(redirectUrl) {
    var _state$elements4 = state.elements,
        submitButton = _state$elements4.submitButton,
        successMessage = _state$elements4.successMessage; // Update button state

    submitButton.disabled = true;
    submitButton.classList.add('success');
    submitButton.value = submitButton.getAttribute('data-success-text'); // Handle redirect or show success message

    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      successMessage.style.display = 'block';
    }
  };
  /**
   * Submit form data to the server
   * @param {string} actionUrl - Form submission endpoint
   * @param {FormData} formData - Form data to submit
   * @param {string|null} redirectUrl - URL to redirect to after success
   */


  var submitForm = function submitForm(actionUrl, formData, redirectUrl) {
    fetch(actionUrl, {
      method: 'POST',
      body: formData,
      mode: 'no-cors'
    }).then(function () {
      return showSuccess(redirectUrl);
    })["catch"](function (error) {
      window.console.error('Error submitting form:', error);
    });
  };
  /**
   * Handle form submission event
   * @param {Event} event - Form submission event
   */


  var handleFormSubmission = function handleFormSubmission(event) {
    event.preventDefault();
    var _state$elements5 = state.elements,
        form = _state$elements5.form,
        nameField = _state$elements5.nameField,
        emailField = _state$elements5.emailField;
    var sanitizedName = sanitize(nameField.value);
    var sanitizedEmail = sanitize(emailField.value);
    var nameValid = NAME_REGEX.test(sanitizedName);
    var emailValid = EMAIL_REGEX.test(sanitizedEmail); // Always validate both fields to show both errors if needed

    if (!nameValid) {
      validateName();
    }

    if (!emailValid) {
      validateEmail();
    }

    if (!nameValid || !emailValid) {
      return;
    }

    var formData = new FormData(form); // overwrite unsafe values with sanitized versions

    formData.set('name', sanitizedName);
    formData.set('email', sanitizedEmail);
    var actionUrl = form.getAttribute('action');
    var redirectInput = form.querySelector('input[name="redirect"]');
    var redirectUrl = redirectInput ? redirectInput.value : null;
    submitForm(actionUrl, formData, redirectUrl);
  };
  /**
   * Set up event listeners
   */


  var setEventListeners = function setEventListeners() {
    var _state$elements6 = state.elements,
        emailField = _state$elements6.emailField,
        nameField = _state$elements6.nameField,
        form = _state$elements6.form,
        submitButton = _state$elements6.submitButton;
    (0, _utils.on)('blur', emailField, validateEmail);
    (0, _utils.on)('input', emailField, validateEmail);
    (0, _utils.on)('blur', nameField, validateName);
    (0, _utils.on)('input', emailField, updateSubmitButtonState);
    (0, _utils.on)('input', nameField, validateName);
    (0, _utils.on)('submit', form, handleFormSubmission); // Add click handler for submit button to show validation errors

    (0, _utils.on)('click', submitButton, function (event) {
      var nameValid = NAME_REGEX.test(sanitize(nameField.value));
      var emailValid = EMAIL_REGEX.test(sanitize(emailField.value)); // Show errors for both fields if validation fails

      validateName();
      validateEmail(); // If form is invalid, prevent default to stop submission

      if (!nameValid || !emailValid) {
        event.preventDefault();
      }
    });
  };
  /**
   * Initialize the newsletter form
   */


  var init = function init() {
    cacheElements(); // Exit early if form doesn't exist on the page

    if (!state.elements.form) return; // Keep submit button enabled to allow clicking

    if (state.elements.submitButton) {
      state.elements.submitButton.disabled = false;
    }

    setEventListeners();
  }; // Public API


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;